import React from 'react';

import { ReactFCV } from '@types';

import { InputWithHeader } from './InputWithHeader';
import {
  SAddressSection,
  SDeliveryAddress,
  SSectionWrapper,
  SHeading,
  SCheckboxWithText,
  SInputWrapper,
} from './styled';

export const AddressSection: ReactFCV = () => (
  <SAddressSection>
    <SHeading width={'40%'} />
    <InputWithHeader postfixDataTestId="email" withText={true} />
    <InputWithHeader postfixDataTestId="phone" withText={true} />
    <SSectionWrapper>
      <SHeading width={'40%'} />
      <SDeliveryAddress>
        <SInputWrapper withRightPadding={true}>
          <InputWithHeader postfixDataTestId="name" />
        </SInputWrapper>
        <SInputWrapper>
          <InputWithHeader postfixDataTestId="surname" />
        </SInputWrapper>
        <SInputWrapper withRightPadding={true}>
          <InputWithHeader postfixDataTestId="street" />
        </SInputWrapper>
        <SInputWrapper>
          <InputWithHeader postfixDataTestId="street-number" />
        </SInputWrapper>
        <SInputWrapper withRightPadding={true}>
          <InputWithHeader postfixDataTestId="town" />
        </SInputWrapper>
        <SInputWrapper>
          <InputWithHeader postfixDataTestId="zipcode" />
        </SInputWrapper>
        <InputWithHeader postfixDataTestId="info" withText={true} />
      </SDeliveryAddress>
    </SSectionWrapper>
    <SSectionWrapper>
      <SHeading width={'40%'} />
      <SCheckboxWithText width={'30%'} />
    </SSectionWrapper>
    <SSectionWrapper>
      <SHeading width={'40%'} />
      <SCheckboxWithText width={'30%'} />
      <SCheckboxWithText width={'30%'} />
      <SCheckboxWithText width={'30%'} />
    </SSectionWrapper>
  </SAddressSection>
);
